"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _memoizeFormElement = _interopRequireDefault(require("../../Utilities/memoizeFormElement"));

var _Form = require("../../Form");

var _Elements = require("../../Components/Elements");

var _Components = require("../../Components");

var _Validations = require("../../Validations");

var _Utilities = require("../../Utilities");

var _StyledTypography = require("../../../StyledTypography");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Textarea = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var name = _ref.name,
      id = _ref.id,
      label = _ref.label,
      value = _ref.value,
      onChange = _ref.onChange,
      validations = _ref.validations,
      submitAttempted = _ref.submitAttempted,
      isRequired = _ref.isRequired,
      placeholder = _ref.placeholder,
      attr = _ref.attr,
      height = _ref.height,
      rows = _ref.rows,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      maximumLength = _ref.maximumLength,
      showCharacterCount = _ref.showCharacterCount,
      characterCountColor = _ref.characterCountColor,
      hideError = _ref.hideError;
  var errorId = (0, _Utilities.getFormErrorId)(validations, submitAttempted);
  return /*#__PURE__*/_react["default"].createElement(_Elements.InputWrapper, {
    className: errorId ? 'form-error' : ''
  }, /*#__PURE__*/_react["default"].createElement(_Components.Label, {
    label: label,
    name: name,
    id: "".concat(id, "-label"),
    isRequired: isRequired,
    htmlFor: id
  }), /*#__PURE__*/_react["default"].createElement(_Elements.StyledTextarea, {
    forwardedRef: ref,
    name: name,
    id: id,
    value: value,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    placeholder: placeholder,
    attr: _objectSpread(_objectSpread({}, attr), {}, {
      'aria-labelledby': "".concat(id, "-label"),
      'aria-invalid': errorId ? true : undefined,
      'aria-required': isRequired ? true : undefined,
      maxLength: maximumLength || undefined
    }),
    height: height,
    rows: rows
  }), showCharacterCount && maximumLength && /*#__PURE__*/_react["default"].createElement(_StyledTypography.Caption, {
    textAlign: "right",
    fontColor: characterCountColor
  }, value.length, "/", maximumLength), !hideError && /*#__PURE__*/_react["default"].createElement(_Components.ErrorMessage, {
    id: errorId,
    values: {
      inputName: label,
      maxLength: maximumLength
    }
  }));
});

Textarea.propTypes = {
  placeholder: _propTypes["default"].string,
  submitAttempted: _propTypes["default"].bool.isRequired,
  validations: _propTypes["default"].object,
  value: _propTypes["default"].string,
  name: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  attr: _propTypes["default"].object,
  isRequired: _propTypes["default"].bool,
  maximumLength: _propTypes["default"].number,
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].node]).isRequired,
  showCharacterCount: _propTypes["default"].bool,
  characterCountColor: _propTypes["default"].string,
  hideError: _propTypes["default"].bool
};
Textarea.defaultProps = {
  attr: {},
  isRequired: false,
  maximumLength: undefined,
  validations: {},
  placeholder: '',
  height: null,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  showCharacterCount: false,
  characterCountColor: 'mediumGrey',
  hideError: false
};
Textarea.Validations = {
  required: _Validations.required,
  maxLength: _Validations.maxLength
};
Textarea.displayName = 'Textarea';
var MemoTextarea = (0, _memoizeFormElement["default"])(Textarea);

var _default = (0, _Form.asFormElement)(MemoTextarea);

exports["default"] = _default;